import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { update_pt_prospect } from "../../../data/ApiEndpoints";
import Loader from "../../ui/Loader";

const ClosureDateChange = ({
  userInfoData,
  rowData,
  callFunction,
  closeModal,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const iniFormValues = {
    expectedClosureDate: rowData?.expected_closure_date || "",
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, value } = e.target;

    setIsSubmit(false);

    setFormValues((prevs) => ({
      ...prevs,
      [name]: value,
    }));
  };

  const validateForm = (formValues) => {
    let errors = {};

    if (!formValues.expectedClosureDate) {
      errors.expectedClosureDate = "Expected Closure Date Is Required!";
    }

    return errors;
  };

  const onSubmit = (e) => {
    e.preventDefault();

    setFormErrors(validateForm(formValues));
    setIsSubmit(true);
  };

  const handleSubmitForm = async (payload) => {
    const method = "PUT";
    const endpoint = update_pt_prospect;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(iniFormValues);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage =
          result?.payload?.data ||
          result?.payload?.message ||
          result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        uid: rowData?.prospect_id || "",
        expected_closure_date: formValues.expectedClosureDate || "",
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `You Want To Submit The Form!`,
        "No",
        "Yea"
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="paymentLinkForm">
      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="expectedClosureDate" className="formInputLabel">
              Expected closure date <span className="required">*</span>
            </label>

            <input
              type="date"
              min={new Date().toISOString().split("T")[0]}
              max={
                new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
                  .toISOString()
                  .split("T")[0]
              }
              className={`formInput ${
                formErrors.expectedClosureDate ? "formError" : ""
              } ${formValues.expectedClosureDate ? "date-has-value" : ""}`}
              name="expectedClosureDate"
              value={formValues.expectedClosureDate}
              onChange={(e) => {
                const minDate = new Date(
                  new Date().toISOString().split("T")[0]
                );
                const maxDate = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
                const selectedDate = new Date(e.target.value);

                if (selectedDate >= minDate && selectedDate <= maxDate) {
                  onChangeInput(e);
                } else {
                  e.target.value = "";
                  alert(
                    `Please select a date within the allowed range: ${minDate.toLocaleDateString()} to ${maxDate.toLocaleDateString()}.`
                  );
                }
              }}
            />
          </div>
        </div>

        <div
          className="formButtons"
          style={{ justifyContent: "flex-end", marginTop: "20px" }}
        >
          <Button
            type="submit"
            className="saveBtn"
            variant="danger"
            onClick={onSubmit}
          >
            {postPutLoading ? <Loader /> : "update closure date"}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ClosureDateChange;
